<template>
  <b-container>
    <div class="vdist">
      <section>
        <b-alert variant="info" show>
          Należy przesłać archiwum .zip zawierające na najwyższym poziomie dokładnie trzy katalogi: "sole", "vamp", "heel" a w każdym z nich zdjęcia o tych samych nazwach, w formacie .png. Maksymalny rozmiar archiwum to 10GB i maksymalnie 5k butów.

        </b-alert>
      </section>
      <b-row>
        <b-col cols="12" md="6">
          <Etl :axios="axios" :enabled="true" info="Pary na podstawie hashy w nazwach plików. Zdjęcia muszą mieć nazwy postaci: HHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHH_DDDD-DD-DD_DD_DD_DD.DDD.png i posiadać swoje pary (hash powtarza się dwa razy)" endpoint="etl/hash"
               title="po hashu"></Etl>
        </b-col>
        <b-col cols="12" md="6">
          <Etl :axios="axios" :enabled="true"
               info="Pary zostaną utworzone z wykorzystaniem uczenia maszynowego. Puste wieszaki zostaną w tym trybie wykryte." endpoint="etl/smart"
               title="Alinka powered"></Etl>
        </b-col>
      </b-row>
      <h3>historia</h3>
      <div class="vdist">
        <b-card v-for="ur in uploads" :key="ur.id" class="vdist">
          <b-row>
            <b-col>
              id
              <h5>{{ ur.id }}</h5>
            </b-col>
            <b-col>
              plik
              <h5>{{ ur.filename }}</h5>
            </b-col>
            <b-col>
              utworzony
              <h5>{{ ur.created }}</h5>
            </b-col>
            <b-col>
              metoda
              <h5>{{ ur.method }}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col :class="statusClass('UPLOADED', ur)">przesyłanie</b-col>
            <b-col :class="statusClass('EXTRACTED', ur)">rozpakowywanie</b-col>
            <b-col :class="statusClass('VALIDATED', ur)">walidowanie</b-col>
            <b-col :class="statusClass('PAIRED', ur)">parowanie</b-col>
            <b-col :class="statusClass('COMPLETED', ur)">gotowe</b-col>
          </b-row>
          <b-row v-if="ur.error!==null" class="vdist">
            <b-col>
              błąd
              <h5>{{ ur.error }}</h5>
            </b-col>
          </b-row>


        </b-card>
      </div>
    </div>
  </b-container>


</template>

<script>

import {api} from '@/utils'
import Etl from "@/components/Etl";

export default {
  name: 'EtlPage',
  components: {Etl},
  props: ["axios"],
  data: function () {
    return {
      file: '',
      uploadPercentage: 0,
      uploads: [],
      interval:null
    }
  },
  created() {
    this.interval = setInterval(this.loadUploads, 3000)
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    loadUploads() {
      this.axios.get(api("etl")).then((resp) => {
        this.uploads = resp.data.uploads;
      })
    },
    statusClass(statusValue, upload){
      if(statusValue===upload.status)
        return upload.error===null ? "bg-primary" : "bg-danger"
      else
        return "bg-light"

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.on {
  background: red
}
</style>
